import React from 'react'
import { Icon } from '@rsuite/icons';

const SpliceSvg = React.forwardRef((props: any, ref) => {
    const viewBox = `0 0 24 24`
    return <svg 
    {...props}
    stroke="currentColor" 
    fill="currentColor" 
    strokeWidth="0" 
    viewBox={viewBox}
    color={props.color}
    height={props.size}
    width={props.size}
    xmlns="http://www.w3.org/2000/svg" 
    style={props.style}
    >
        <g>
        <title>Layer 1</title>
        <path id="svg_1" d="m0,0l24,0l0,24l-24,0l0,-24z" fill="none"/>
        <path id="svg_2" d="m6.00732,6l-1.41,1.41l4.58,4.59l-4.58,4.59l1.41,1.41l6,-6l-6,-6z"/>
        <path id="svg_3" d="m19.41,7.41l-1.41,-1.41l-6,6l6,6l1.41,-1.41l-4.58,-4.59l4.58,-4.59z"/>
        </g>
    </svg>
});


const SpliceSvgIcon = React.forwardRef((props, ref) => {
    
    return <Icon as={SpliceSvg} {...props}/>
});


export default SpliceSvgIcon